import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "sales-horizon-chart" }
const _hoisted_2 = { class: "row g-2 mb-3" }
const _hoisted_3 = { class: "sales-horizon-chart__stat rounded-2 h-100" }
const _hoisted_4 = { class: "small text-muted" }
const _hoisted_5 = { class: "fw-semibold" }
const _hoisted_6 = { class: "small text-muted" }
const _hoisted_7 = { class: "sales-horizon-chart__canvas" }
const _hoisted_8 = { ref: "canvas" }
const _hoisted_9 = { class: "sales-horizon-chart__legend d-flex flex-wrap justify-content-center mt-2" }
const _hoisted_10 = { class: "text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summary, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.label,
          class: "col"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(item.label), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.value), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.note), 1)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("canvas", _hoisted_8, null, 512)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("span", _hoisted_10, [
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "sales-horizon-chart__symbol sales-horizon-chart__symbol--column" }, null, -1)),
        _createTextVNode("Cena podle doby " + _toDisplayString(_ctx.chart.offerType === 'lease' ? 'pronájmu' : 'prodeje'), 1)
      ]),
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-nowrap" }, [
        _createElementVNode("span", { class: "sales-horizon-chart__symbol sales-horizon-chart__symbol--estimate" }),
        _createTextVNode("Odhadní cena")
      ], -1))
    ])
  ]))
}